<template>
  <div id="form">
    <div id="headerText" v-if="!viewAlert && !viewProgress">
      <p id="firstMessage">Registro de Referencias Laborales {{assignment.id}}</p>
                   <p id="secondMessage">
        ¡Hola {{project.first_name}} {{project.last_name}}! Aquí podrás registrar tus referencias laborales; por favor ingresa solo información de las referencias con las que si nos autorices generar contacto.
        <br> 
      </p>
      <p id="secondMessage">Si tienes alguna duda, puedes comunicarte con nosotros al número (+57) 320 472 59 21 o en <a href="www.globalwork.co">www.globalwork.co</a></p>
      <p id="secondMessage">Certifico que la información que estoy brindando es verídica y corresponde a fuentes reales de información</p>
    </div>
   <div v-if="!viewAlert && !viewProgress" class="" id="divForm" style="">

      <template v-if="!done">
        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Nombre de la empresa</p>
            <input type="text" v-model="reference.company_name" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Cargo desempeñado</p>
            <input type="text" v-model="reference.charge" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Fecha inicial de trabajo</p>
            <input type="date" v-model="reference.start_at" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <label class="myLabel">
              ¿Sigues actualmente en la empresa?
              <input type="checkbox" v-model="working" min="1" max="10">
            </label>
          </div>
        </div>


        <div class="" v-if="!working" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Fecha final de trabajo</p>
            <input type="date" v-model="reference.leave_at" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Nombre de la referencia</p>
            <input type="text" v-model="reference.contact_name" class="myImput" />
          </div>
        </div>


        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Cargo de la referencia</p>
            <input type="text" v-model="reference.contact_charge" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Teléfono (Celular) de la referencia</p>
            <input type="text" v-model="reference.contact_telephone" @keypress="regExpressionOnlyNumbers" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <p class="myLabel" for="observations">Email de la referencia</p>
            <input type="text" v-model="reference.email" class="myImput" />
          </div>
        </div>

        <div class="" style="margin:24px">
          <div >
            <button class="mybutton" @click="saveReference" id="saveReference">Guardar Información</button>
          </div>
        </div>      

      </template>
      <p id="firstMessage" v-else>La información ha sido diligenciada</p>

    </div>

    <div v-if="viewAlert && !viewProgress" id="greatingText" >
      <p id="greatText">¡Muchas gracias por tu información!</p>
      <p id="explainGreat">
        Somos Globalwork. Una compañía que crea vínculos confiables en procesos <br> de selección a través de visitas domiciliarias y estudios de seguridad
      </p>
    </div>
    <div v-if="viewAlert && !viewProgress" id="aboutUs" style="position: relative;
    top: 25vh;
    text-align: center;">
      <img id="serviceImg" src="https://www.globalwork.co/wp-content/uploads/2020/05/icon-verificacion-antecedentes-home.svg" alt="">
      <p id="firstInformativeText">
        ¿Quieres saber más acerca de nuestros Estudios de Seguridad?  
      </p>
      <a id="secodnInformativeText" href="https://www.globalwork.co/">
        Conoce más de nuestro servicio
      </a>  
    </div>
    <div id="messagesSaving" v-if="viewProgress && !viewAlert">
      <p id="savingMessage">{{alertMessage}}</p>
      <button  class="mybutton" id="closeButton" v-if="changeItem" @click="viewProgress = !viewProgress">Cerrar</button>
      <div v-if="!changeItem" class="pro-bar-container">
        <div class="pro-bar pro-bar-width" data-pro-bar-percent="80">
         <div class="pro-bar-candy"></div>
        </div>
      </div>
    </div>

    <div v-if="references.length > 0 && !viewProgress" id="references">
      <p @click="viewTable = !viewTable">{{message}}</p>
      <table v-if="viewTable" id="referencesTable">
        <thead>
          <tr>
           <th>Nombre Referencia</th>
           <th>Telefono Referencia</th>
           <th>Email Referencia</th>
           </tr>
        </thead>
        <tbody>
          <tr v-for="ref in references" :key="ref.telephone">
            <td>{{ref.contact_name}}</td>
            <td>{{ref.contact_telephone}}</td>
            <td>{{ref.email}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>
</template>

<script>
const Multiselect =() => import('vue-multiselect')
import axios from 'axios'
import Autocomplete from './../../own/autocomplete-local'
export default {
  name:'RegisterReferences',
  props:['project','assignment'],
  data(){
    return{
      viewAlert:false,
      source: '',
      viewProgress:false,
      working:false,
      reference:{},
      references:[],
      viewTable:false,
      message:'Ver Referencias',
      alertMessage: '',
      changeItem:false,
      done: false,      
    }
  },
  methods:{
    async saveReference(){
      this.alertMessage = 'Guardando tu información'
      let str = /[^0-9]/g;
      this.reference.contact_telephone = this.reference.contact_telephone.replace(str,'')
      this.changeItem = false
      this.viewProgress = true
      this.reference.source_create = this.source
      this.reference.project_id = this.project.id
      //this.reference.response_request_information_candidate = true
      this.reference.authorize_contact = true
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      
      let response = await axios.post(`/laboral_references/`,{reference: this.reference})
      
      if(response.status == 201 || response.status == 200) {
        this.references.push(this.reference)
        this.reference = {}
        if(this.references.length == 1) {
          this.alertMessage = `¡Muy bien! Ya has registrado tu primera`+' referencia Puedes registrar cuantas quieras'
          this.changeItem = true
        }else{
          this.viewProgress = false
        }
      }
    },
    regExpressionOnlyNumbers(event) {
      let regex = new RegExp("^[0-9]+$")
      let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
         event.preventDefault();
         return false;
      }
    },    
  },
  computed:{
    
  },
  components:{
    'multiselect':Multiselect,
    'autocomplete':Autocomplete
  },
  created(){
    if (this.project.status == 6) {
      this.viewAlert = true
    }
    const source = window.location.search.split('source=')[1]
    if (source != null) {
      this.source = source
    }
  },
  watch:{
    values(val){
      console.log(this.values)
    },
    viewTable(val){
      console.log(val)
      val == true ?  this.message = 'Ocultar Referencias' : this.message = 'Ver Referencias' 
    },
    'reference.contact_telephone'(val) {
      let str = /[^0-9]/g;
      this.reference.contact_telephone = this.reference.contact_telephone.replace(str,'')
    }
  },
  mounted () {
    if (this.assignment != null) {
      if (this.assignment.status == 4) this.done = true
    }
  },
}
</script>

<style>

</style>